// @flow
import { useSelector, useDispatch } from "react-redux";
import { useCallback } from "react";
import { fetchUserDetails } from '../actions/user';

const useUser = () =>  {
  const user = useSelector(state => state.user);
  const { mobile } = user || {};
  const dispatch = useDispatch();

  const fetchUserDetailsCb = useCallback(
    () => {
      dispatch(fetchUserDetails(mobile));
    },
    [dispatch, mobile]);

  return [user, fetchUserDetailsCb];
}

export default useUser;